import { ECloneWorldMarkerStoryCloneType } from '__generated__/globalTypes';
import { useCloneWorldMarker } from 'hooks/marker/useCloneWorldMarker';
import { useContext } from 'react';
import { CtxEdit } from 'session/ctxEdit';
import { CtxModal } from 'session/ctxModal';

export const useKeyDownListener = () => {
    const ctxEdit = useContext(CtxEdit);
    const ctxModal = useContext(CtxModal);
    const cloneMarker = useCloneWorldMarker();

    function keyDownMarkerMovement(e: KeyboardEvent) {
        if (ctxEdit.selectedMarkers.length) {
            if (e.shiftKey) {
                if (['ArrowUp', 'ArrowRight', 'ArrowDown', 'ArrowLeft'].includes(e.key)) {
                    ctxEdit.selectedMarkers.forEach((markerId) => {
                        const marker = ctxEdit.worldMarkers.find((e) => e.id === markerId);
                        const point = ctxEdit.mapRef?.current
                            .getMap()
                            .project([marker.lng, marker.lat]);

                        const newX =
                            point.x +
                            Number(e.key === 'ArrowRight') -
                            Number(e.key === 'ArrowLeft');
                        const newY =
                            point.y + Number(e.key === 'ArrowDown') - Number(e.key === 'ArrowUp');

                        const newLatLng = ctxEdit.mapRef?.current?.getMap().unproject([newX, newY]);

                        console.log('newPosition', marker.lat, marker.lng, point, newX, newY);

                        ctxEdit.updateWorldMarker(markerId, {
                            lat: newLatLng?.lat,
                            lng: newLatLng?.lng
                        });
                    });

                    e.preventDefault();
                }

                if (e.key === 'Backspace' || e.key === 'Delete') {
                    ctxEdit.removeWorldMarkers(ctxEdit.selectedMarkers);

                    e.preventDefault();
                }
            }
        }
    }

    // function forMultiMarkerSelection(e: KeyboardEvent) {
    //     if (ctxEdit.selectedMarkers?.length > 1) {
    //         if (e.key === 'Escape') {
    //             console.log('Escape multi');
    //             ctxEdit.setSelectedMarkers([]);
    //             ctxEdit.setWorldAction(EWorldAction.SELECT);
    //         }
    //     }
    // }

    // function forSingleMarkerSelection(e: KeyboardEvent) {
    //     const isSelectAction = ctxEdit.worldAction === EWorldAction.SELECT;
    //     const selectedMarker = worldMarker.getSingleMarkerIfOne();

    //     if (isSelectAction && selectedMarker) {
    //         if (e.key === 'Escape') {
    //             console.log('Escape single');
    //             if (ctxEdit.protoMode === EProtoMode.SELECTED) {
    //                 ctxEdit.setProtoMode(EProtoMode.DRAG);
    //             } else {
    //                 ctxEdit.setSelectedMarkers([]);
    //                 ctxEdit.setWorldAction(EWorldAction.SELECT);
    //             }
    //         }
    //     }
    // }

    function forDelete(e: KeyboardEvent) {
        if (ctxEdit.selectedMarkers?.length > 0) {
            if (e.key === 'Delete') {
                console.log('Delete');
                ctxEdit.removeWorldMarkers(ctxEdit.selectedMarkers);
            }
        }
    }

    function forMarkerClone(e: KeyboardEvent) {
        if (e.shiftKey && e.key === 'C') {
            if (ctxEdit.selectedMarkers?.length === 1) {
                const markerId = ctxEdit.selectedMarkers[0];

                cloneMarker(markerId, {
                    cloneInteractivity: ECloneWorldMarkerStoryCloneType.EMPTY
                });
            }
        }
    }

    function forHistory(e: KeyboardEvent) {
        if (e.key === 'z') {
            if (e.ctrlKey || e.metaKey) {
                if (e.shiftKey) {
                    console.log('keys', 'forward');
                    ctxEdit.editHistory.actions.goForwardInHistory();
                } else {
                    console.log('keys', 'back');
                    ctxEdit.editHistory.actions.goBackInHistory();
                }

                e.preventDefault();
            }
        }
    }

    function forModals(e: KeyboardEvent) {
        if (e.key === 'Escape') {
            console.log('Modal');
            ctxModal.setModal(null);
        }
    }

    function keyDown(e: KeyboardEvent) {
        if (ctxEdit.mapRef?.current) {
            // forMultiMarkerSelection(e);
            // forSingleMarkerSelection(e);
            forDelete(e);
            // forNothing(e);
            forModals(e);
            forMarkerClone(e);
        }
    }

    function keyDownHistory(e: KeyboardEvent) {
        forHistory(e);
    }

    return {
        keyDown,
        keyDownHistory,
        keyDownMarkerMovement
    };
};
